import { IntegrationToken, IntegrationType } from "@supernova-studio/model";
import { z } from "zod";
export const IntegrationOauthPlatform = z.enum(["Desktop", "Browser"]);
export const IntegrationOauthCallbackState = z.enum(["Success", "Error"]);
export const DTOWorkspaceIntegrationOauthInput = z.object({
    type: IntegrationType,
    platform: IntegrationOauthPlatform.optional().default("Browser"),
    authId: z.string().optional(), // Allow FE client to distinguish between multiple parallel OAuth flows, useful for desktop where multiple flows can be initiated in parallel
});
export const DTOWorkspaceIntegrationPATInput = z.object({
    type: IntegrationType,
    token: IntegrationToken,
});
export const DTOWorkspaceIntegrationGetGitObjectsInput = z.object({
    organization: z.string().optional(), // Azure Organization | Bitbucket Workspace slug | Gitlab Group and Sub-Groups | Github Account (User or Organization)
    project: z.string().optional(), // Only for Bitbucket and Azure
    repository: z.string().optional(), // For all providers. Pay attention for Gitlab, they call repositories "projects".
    branch: z.string().optional(), // For all providers, useful for PR creations.
    user: z.string().optional(), // Only for Gitlab User Repositories
});
